import { Link, useLocation } from 'react-router-dom';
import './DashboardReturnBar.css';

export default function DashboardReturnBar() {
  const location = useLocation();
  let user = null;
  try { user = JSON.parse(localStorage.getItem('hp_user') || 'null'); } catch {}

  if (!user) return null;

  // Business user, but not currently on a /business/* page
  if (user.type === 'business' && !location.pathname.startsWith('/business')) {
    return (
      <Link to="/business/dashboard" className="return-bar return-bar-business">
        <span className="return-bar-icon">📊</span>
        <span className="return-bar-text">
          Logged in as <strong>{user.business_name || 'your restaurant'}</strong>
        </span>
        <span className="return-bar-cta">Back to dashboard →</span>
      </Link>
    );
  }

  // Admin user, but not currently on the /admin page
  if (user.type === 'admin' && location.pathname !== '/admin' && location.pathname !== '/admin/login') {
    return (
      <Link to="/admin" className="return-bar return-bar-admin">
        <span className="return-bar-icon">⚡</span>
        <span className="return-bar-text">Admin mode active</span>
        <span className="return-bar-cta">Back to admin panel →</span>
      </Link>
    );
  }

  return null;
}
